// extracted by mini-css-extract-plugin
export default {"wrapper":"PropDetailSummary_wrapper__EoqMN","detailInfo":"PropDetailSummary_detailInfo__pWqq2","detailLabel":"PropDetailSummary_detailLabel__o+K8i"};